import { IsInt, IsNotEmpty, IsOptional, IsString, IsUUID, Min } from 'class-validator';

export class PosItemDto {
  id: string;
  name: string;
  amount: number;
  eventBaseId: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;
}

export class CreatePosItemDto {
  @IsString()
  @IsOptional()
  name?: string;

  @IsInt()
  @Min(0)
  amount: number;

  @IsUUID()
  @IsNotEmpty()
  eventBaseId: string;
}

export class UpdatePosItemDto {
  @IsString()
  @IsNotEmpty()
  @IsOptional()
  name?: string;

  @IsInt()
  @Min(0)
  @IsOptional()
  amount?: number;
}
